module.exports = __webpack_public_path__ + "static/media/VERSION.c026153c.bin";